import { ApiQueryConfig, Organization } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type SubscriberPathParams = { $subscriberId: number };

type GetSubscriberConfig = ApiQueryConfig<Organization, SubscriberPathParams>;

const url = `${URLS.app}/api/Organizations/$subscriberId/Details`;

export const getSubscriber = createApiEndpoint<GetSubscriberConfig>({
  method: 'GET',
  url: url,
});
